export default "__VITE_ASSET__Ch336KMQ__"